var findScrollContainer = function (element) {
    if (!element) {
        return undefined;
    }
    var parent = element.parentElement;
    while (parent) {
        var overflow = window.getComputedStyle(parent).overflow;
        if (overflow.split(' ').every(function (o) { return o === 'auto' || o === 'scroll'; })) {
            return parent;
        }
        parent = parent.parentElement;
    }
    return document.documentElement;
};
export var scrollToRef = function (ref) {
    var el = ref.current;
    setTimeout(function () {
        var _a;
        if (!el)
            return;
        var parent = findScrollContainer(el);
        (_a = parent === null || parent === void 0 ? void 0 : parent.scrollTo) === null || _a === void 0 ? void 0 : _a.call(parent, { top: parent.scrollTop + el.getBoundingClientRect().y });
    }, 50);
};
export var scrollToParentTop = function (ref) {
    var el = ref.current;
    setTimeout(function () {
        var _a, _b;
        if (!el)
            return;
        (_b = (_a = findScrollContainer(el)) === null || _a === void 0 ? void 0 : _a.scrollTo) === null || _b === void 0 ? void 0 : _b.call(_a, { top: 0 });
    }, 50);
};
